/* MUSHROOM MADNESS, 8 Oct 2026. The script of templates/page.lp-madness.liquid (styles: lp-madness.css).
   Four jobs: the clock, the builder (pick three, pay for two), the checkout link, the draw (today's match, a vote, the bracket).
   Everything it needs is printed by the template: the catalogue (#mmCat), the sale (data-* on #mm), the draw (data-* on #mmDraw).
   A test: ?mmnow=2026-10-13 or ?mmnow=2026-10-26T00:00:00Z in the address shows the page on another day. */
(function () {
  'use strict';
  var root = document.getElementById('mm');
  if (!root) return;
  var $ = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return [].slice.call((c || root).querySelectorAll(s)); };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  function track(name, data) {
    var d = data || {};
    try { (window.dataLayer = window.dataLayer || []).push(Object.assign({ event: name, lp: 'lp-madness' }, d)); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(name, d); } catch (e) {}
  }

  /* ── the time (UK), with a test override ─────────────────────────────────────────────────────── */
  var OFFSET = 0;
  (function () {
    var m = /[?&]mmnow=([^&#]+)/.exec(location.search || '');
    if (!m) return;
    var v = decodeURIComponent(m[1]);
    var t = Date.parse(/^\d{4}-\d{2}-\d{2}$/.test(v) ? v + 'T12:00:00Z' : v);
    if (!isNaN(t)) OFFSET = t - Date.now();
  })();
  function now() { return new Date(Date.now() + OFFSET); }
  function ukDay(d) {
    try {
      var p = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d), o = {};
      p.forEach(function (x) { o[x.type] = x.value; });
      return o.year + '-' + o.month + '-' + o.day;
    } catch (e) { return d.toISOString().slice(0, 10); }
  }
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function span(a, b) {           /* 2026-10-09, 2026-10-10 → "9–10 Oct" */
    var da = +a.slice(8), db = +b.slice(8), ma = MONTHS[+a.slice(5, 7) - 1], mb = MONTHS[+b.slice(5, 7) - 1];
    if (a === b) return da + ' ' + ma;
    return ma === mb ? da + '–' + db + ' ' + ma : da + ' ' + ma + ' – ' + db + ' ' + mb;
  }

  /* ── A · the clock, and the end of the event ─────────────────────────────────────────────────── */
  var END = Date.parse(root.getAttribute('data-end'));
  var SHOP = root.getAttribute('data-shop') || '/collections/shop-all';
  var over = false;
  function setOver() {
    if (over) return;
    over = true;
    root.classList.add('is-over');
    var bar = $('#mmBar'); if (bar) bar.classList.remove('on');
    root.style.setProperty('--bar-h', '0px');
    $$('a[data-go]').forEach(function (a) { a.setAttribute('href', SHOP); a.removeAttribute('aria-disabled'); });
  }
  function tick() {
    var left = END - now().getTime();
    if (!(left > 0)) { setOver(); return; }
    var mins = Math.floor(left / 60000), d = Math.floor(mins / 1440), h = Math.floor((mins % 1440) / 60), m = mins % 60;
    var cd = $('#mmCd');
    if (cd) {
      $('[data-d]', cd).textContent = d; $('[data-h]', cd).textContent = h; $('[data-m]', cd).textContent = m;
      cd.setAttribute('aria-label', d + ' days, ' + h + ' hours and ' + m + ' minutes left');
    }
  }
  tick();
  var timer = setInterval(function () { tick(); if (over) clearInterval(timer); }, 15000);

  /* ── money, in the store's own format ────────────────────────────────────────────────────────── */
  var money = (function (sample) {             /* the template prints 12,345.67 in the store's format: read the format off it */
    var m = /^(.*?)(\d[\d.,'\s  ]*\d)(.*)$/.exec(sample || '');
    if (!m) return function (c) { return (c / 100).toFixed(2); };
    var num = m[2], dm = /([^\d])67$/.exec(num), dec = dm ? dm[1] : '';
    var body = dec ? num.slice(0, -3) : num, tm = /[^\d]/.exec(body), th = tm ? tm[0] : '';
    return function (c) {
      var whole = dec ? Math.floor(c / 100) : Math.round(c / 100);
      var s = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, th);
      return m[1] + s + (dec ? dec + ('0' + (c % 100)).slice(-2) : '') + m[3];
    };
  })(root.getAttribute('data-money'));

  /* ── C · the builder ─────────────────────────────────────────────────────────────────────────── */
  var CAT = [];
  try { CAT = JSON.parse($('#mmCat').textContent) || []; } catch (e) { CAT = []; }
  var BY = {};
  CAT.forEach(function (it, i) { it.i = i; BY[it.id] = it; });
  if (CAT.length !== +root.getAttribute('data-found') || CAT.length < 32) {
    try { console.warn('[madness] ' + CAT.length + ' packs on the page; 32 expected. Check the shop-all collection and mm_list.'); } catch (e) {}
  }
  var CODE = root.getAttribute('data-code') || 'MADNESS';
  var FREESHIP = +root.getAttribute('data-freeship') || 0;
  var MAXQ = 9;
  var qty = {};
  try {
    var saved = JSON.parse(sessionStorage.getItem('mm-picks') || '{}');
    Object.keys(saved).forEach(function (id) { if (BY[id] && BY[id].available && saved[id] > 0) qty[id] = Math.min(MAXQ, saved[id] | 0); });
  } catch (e) {}

  /* the sum: the free ones are the cheapest units picked: one for 3 to 5, two for 6 or more, never more than two */
  function sum() {
    var units = [];
    CAT.forEach(function (it) { for (var k = 0; k < (qty[it.id] || 0); k++) units.push(it); });
    var n = units.length, free = n >= 6 ? 2 : n >= 3 ? 1 : 0;
    var asc = units.slice().sort(function (a, b) { return a.price - b.price || a.i - b.i; });
    var total = 0, save = 0, freeIds = {};
    units.forEach(function (u) { total += u.price; });
    asc.slice(0, free).forEach(function (u) { save += u.price; freeIds[u.id] = (freeIds[u.id] || 0) + 1; });
    return { n: n, free: free, total: total, save: save, pay: total - save, freeIds: freeIds };
  }
  function link() {
    var parts = [];
    CAT.forEach(function (it) { if (qty[it.id] > 0) parts.push(it.id + ':' + qty[it.id]); });
    return '/cart/' + parts.join(',') + '?discount=' + encodeURIComponent(CODE);
  }

  var bar = $('#mmBar'), barS = $('#mmBarS'), barN = $('#mmBarN'), barF = $('#mmBarF'), go = $('#mmGo'), pips = $('#mmPips');
  var inView = false;
  var WORD = ['', 'One', 'Two'];

  function paintCard(card) {
    var id = card.getAttribute('data-vid'), q = qty[id] || 0, add = $('[data-add]', card), box = $('.mm-qty', card);
    if (!add || !box) return;
    card.classList.toggle('is-in', q > 0);
    add.hidden = q > 0; box.hidden = q === 0;
    $('[data-n]', box).textContent = q;
    $('[data-inc]', box).disabled = q >= MAXQ;
  }
  function paint() {
    var s = sum();
    $$('.mm-card').forEach(function (c) { c.classList.toggle('is-free', !!s.freeIds[c.getAttribute('data-vid')]); });
    if (over) return;
    /* the words */
    var line = '', nudge = '';
    if (s.n === 0) line = 'Pick any three: the cheapest is free';
    else if (s.n === 1) line = 'Two more and one is free';
    else if (s.n === 2) line = 'One more: it is free';
    else {
      line = '<span>' + s.n + ' picked</span> &middot; <span><s>' + esc(money(s.total)) + '</s> &rarr; <b>' + esc(money(s.pay)) + '</b></span> &middot; <span>you save ' + esc(money(s.save)) + '</span>';
      if (s.n > 3 && s.n < 6) nudge = 'Add ' + (6 - s.n) + ' more for a second free one';
      else if (s.n >= 6) nudge = 'Two free: the most on one order';
    }
    barS.innerHTML = line;
    barN.textContent = nudge; barN.hidden = !nudge;
    var small = 'Final total is confirmed at checkout.';
    if (FREESHIP && s.n >= 3) small += s.pay >= FREESHIP ? ' Free UK delivery.' : ' Free UK delivery over ' + money(FREESHIP) + '.';
    barF.textContent = small; barF.hidden = s.n < 3;
    /* the pips: three, then six */
    var want = s.n > 3 ? 6 : 3, have = pips.children.length;
    for (; have < want; have++) pips.appendChild(document.createElement('i'));
    for (; have > want; have--) pips.removeChild(pips.lastChild);
    [].forEach.call(pips.children, function (p, i) { p.classList.toggle('on', i < s.n); });
    /* the button */
    if (s.n >= 3) {
      go.setAttribute('href', link()); go.removeAttribute('aria-disabled');
      go.innerHTML = 'Checkout <span aria-hidden="true">&rarr;</span>';
    } else {
      go.removeAttribute('href'); go.setAttribute('aria-disabled', 'true');
      go.textContent = s.n === 0 ? 'Pick 3' : 'Pick ' + (3 - s.n) + ' more';
    }
    bar.classList.toggle('is-go', s.n >= 3);
    showBar(s.n);
    try { sessionStorage.setItem('mm-picks', JSON.stringify(qty)); } catch (e) {}
  }
  function showBar(n) {
    var on = !over && (inView || n > 0);
    bar.classList.toggle('on', on);
    root.style.setProperty('--bar-h', on ? bar.offsetHeight + 'px' : '0px');
  }
  function change(id, by) {
    var it = BY[id]; if (!it || !it.available) return;
    var q = Math.max(0, Math.min(MAXQ, (qty[id] || 0) + by));
    if (q) qty[id] = q; else delete qty[id];
    paint();
    track(by > 0 ? 'mm_add' : 'mm_remove', { variant: id, name: it.short, count: sum().n });
  }
  var build = $('#builder');
  if (build) {
    build.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('button') : null; if (!b) return;
      var card = b.closest('.mm-card'); if (!card) return;
      var id = card.getAttribute('data-vid');
      if (b.hasAttribute('data-add') || b.hasAttribute('data-inc')) {
        change(id, 1); paintCard(card);
        if (b.hasAttribute('data-add')) { var inc = $('[data-inc]', card); if (inc) inc.focus(); }
      } else if (b.hasAttribute('data-dec')) {
        change(id, -1); paintCard(card);
        if (!qty[id]) { var add = $('[data-add]', card); if (add) add.focus(); }
      }
    });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; showBar(sum().n); }, { rootMargin: '0px 0px -30% 0px' }).observe(build);
    } else { inView = true; }
  }
  $$('.mm-card').forEach(paintCard);
  paint();
  window.addEventListener('resize', function () { showBar(sum().n); }, { passive: true });
  if (go) go.addEventListener('click', function (e) {
    if (go.getAttribute('aria-disabled') === 'true') { e.preventDefault(); return; }
    var s = sum(); track(over ? 'mm_ended_shop' : 'mm_checkout', { count: s.n, value: s.pay / 100, saved: s.save / 100 });
  });
  $$('a[data-go="hero"],a[data-go="ended"]').forEach(function (a) { a.addEventListener('click', function () { track('mm_cta', { where: a.getAttribute('data-go') }); }); });

  /* the chip row: the group on screen is the dark chip */
  var chips = $$('.mm-chips a'), groups = $$('.mm-grp');
  function markChip(g) {
    chips.forEach(function (c) {
      var on = c.getAttribute('data-chip') === g;
      if (on) { c.setAttribute('aria-current', 'true'); if (c.scrollIntoView && c.parentNode.scrollWidth > c.parentNode.clientWidth) c.parentNode.scrollLeft = c.offsetLeft - 16; }
      else c.removeAttribute('aria-current');
    });
  }
  if (groups.length && 'IntersectionObserver' in window) {
    var seen = {};
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { seen[x.target.getAttribute('data-grp')] = x.isIntersecting; });
      for (var i = 0; i < groups.length; i++) { var g = groups[i].getAttribute('data-grp'); if (seen[g]) { markChip(g); return; } }
    }, { rootMargin: '-70px 0px -55% 0px' });
    groups.forEach(function (g) { io.observe(g); });
  }
  markChip('p');

  /* ── D · the draw ────────────────────────────────────────────────────────────────────────────── */
  var dz = $('#mmDraw'), matchBox = $('#mmMatch'), brBox = $('#mmBracket');
  if (dz && matchBox && brBox) {
    var SP = {};
    $$('[data-sp]', dz).forEach(function (el) {
      SP[el.getAttribute('data-sp')] = { slug: el.getAttribute('data-sp'), name: el.textContent.trim(), hue: el.getAttribute('data-hue'), img: el.getAttribute('data-img') };
    });
    var ORDER = ['m1', 'm2', 'm3', 'm4', 's1', 's2', 'f'];
    var LABEL = { m1: 'Match 1', m2: 'Match 2', m3: 'Match 3', m4: 'Match 4', s1: 'Semi-final 1', s2: 'Semi-final 2', f: 'Final' };
    var ROUND = { m1: 'Round one', m2: 'Round one', m3: 'Round one', m4: 'Round one', s1: 'Semi-final', s2: 'Semi-final', f: 'The final' };
    var M = {};
    ORDER.forEach(function (id) {
      var b = (dz.getAttribute('data-' + id) || '').split('|').map(function (x) { return x.trim(); });
      M[id] = { id: id, from: b[0] || '', to: b[1] || b[0] || '', a: b[2] || '', b: b[3] || '', winner: (b[4] || '').toLowerCase() };
    });
    var ANNOUNCE = dz.getAttribute('data-announce') || '';
    /* a side is a mushroom, or the winner of an earlier match */
    var side = function (ref) {
      if (SP[ref]) return SP[ref];
      if (M[ref]) { var w = winner(M[ref]); return w || { tbc: true, name: 'Winner of ' + LABEL[ref].toLowerCase() }; }
      return { tbc: true, name: 'To be decided' };
    };
    var winner = function (m) {
      if (!m.winner) return null;
      var a = side(m.a), b = side(m.b);
      if (a.slug === m.winner) return a;
      if (b.slug === m.winner) return b;
      return null;                       /* a slug that is not in this match is ignored */
    };
    var vote = function (id, v) {
      try { if (v === undefined) return localStorage.getItem('mm-vote-' + id) || ''; localStorage.setItem('mm-vote-' + id, v); } catch (e) {}
      return v || '';
    };
    var today = ukDay(now());
    var champ = winner(M.f);
    var cur = null, next = null;
    ORDER.forEach(function (id) { var m = M[id]; if (!cur && m.from <= today && today <= m.to) cur = m; if (!next && today < m.from) next = m; });

    var sideHtml = function (m, s, mine, open) {
      if (s.tbc) return '<div class="mm-side is-tbc"><p class="mm-side-n">' + esc(s.name) + '</p></div>';
      var w = winner(m), cls = 'mm-side mm-h--' + s.hue, btn = '';
      if (w) btn = '<button type="button" class="mm-btn" disabled>' + (w.slug === s.slug ? 'Through' : 'Out') + '</button>';
      else if (mine) btn = '<button type="button" class="mm-btn" disabled>' + (mine === s.slug ? 'You voted ' + esc(s.name) : esc(s.name)) + '</button>';
      else if (open) btn = '<button type="button" class="mm-btn" data-vote="' + s.slug + '">Vote ' + esc(s.name) + '</button>';
      if (w ? w.slug === s.slug : mine === s.slug) cls += ' is-mine';
      else if (w || mine) cls += ' is-other';
      return '<div class="' + cls + '"><img src="' + esc(s.img) + '" width="1000" height="1000" alt="' + esc(s.name) + ' mushroom" loading="lazy" decoding="async">' +
        '<div class="mm-side-b"><p class="mm-side-n">' + esc(s.name) + '</p>' + btn + '</div></div>';
    };
    var tags = function (slug) { var t = $('#mmTags'); if (t) t.value = 'newsletter, mushroom-madness' + (slug ? ', vote-' + slug : ''); };

    var drawMatch = function () {
      if (champ) {
        matchBox.innerHTML = '<div class="mm-match-k"><span>The winner</span><b>Mushroom Madness 2026</b></div><div class="mm-champ">' +
          '<div class="mm-side mm-h--' + champ.hue + ' is-mine"><img src="' + esc(champ.img) + '" width="1000" height="1000" alt="' + esc(champ.name) + ' mushroom"></div>' +
          '<p class="mm-champ-t">' + esc(champ.name) + ' <em>wins.</em></p></div>';
        return;
      }
      var m = cur || next;
      if (!m) {
        matchBox.innerHTML = '<div class="mm-match-k"><span>The final is played</span><b>Winner on ' + span(ANNOUNCE, ANNOUNCE) + '</b></div>' +
          '<p class="mm-champ-t">The winner is announced on <em>Sunday 25 October.</em></p>';
        return;
      }
      var a = side(m.a), b = side(m.b), w = winner(m), open = m === cur && !w && !a.tbc && !b.tbc && !over;
      var mine = open || (m === cur && !w) ? vote(m.id) : '';
      if (mine && mine !== a.slug && mine !== b.slug) mine = '';
      var head = m === cur ? 'Today&rsquo;s match' : 'Next match';
      var note = '';
      if (w) note = esc(w.name) + ' goes through.';
      else if (m !== cur) note = 'Voting opens on ' + span(m.from, m.from) + '.';
      else if (a.tbc || b.tbc) note = 'The names go up as soon as the last round is settled.';
      else if (mine) note = 'Your vote is in. The next match starts on ' + (nextAfter(m) ? span(nextAfter(m).from, nextAfter(m).from) : span(ANNOUNCE, ANNOUNCE)) + '.';
      else note = 'One vote a match. Tap your side.';
      matchBox.innerHTML = '<div class="mm-match-k"><span>' + head + ' &middot; ' + ROUND[m.id] + '</span><b>' + span(m.from, m.to) + '</b></div>' +
        '<div class="mm-vs">' + sideHtml(m, a, mine, open) + sideHtml(m, b, mine, open) + '<span class="mm-v" aria-hidden="true">v</span></div>' +
        '<p class="mm-match-s">' + note + '</p>';
      tags(mine);
    };
    var nextAfter = function (m) { var i = ORDER.indexOf(m.id); return i >= 0 && i < ORDER.length - 1 ? M[ORDER[i + 1]] : null; };

    var rowHtml = function (m, s) {
      if (s.tbc) return '<div class="mm-row is-tbc"><span class="mm-row-i"></span><span>' + esc(s.name) + '</span></div>';
      var w = winner(m), cls = 'mm-row mm-h--' + s.hue + (w ? (w.slug === s.slug ? ' is-won' : ' is-lost') : '');
      return '<div class="' + cls + '"><span class="mm-row-i"><img src="' + esc(s.img) + '" width="80" height="80" alt="" loading="lazy" decoding="async"></span><span>' + esc(s.name) + '</span></div>';
    };
    var mtHtml = function (id) {
      var m = M[id], live = m === cur && !winner(m);
      return '<div class="mm-mt' + (live ? ' is-live' : '') + '"><div class="mm-mt-k"><span>' + LABEL[id] + ' &middot; ' + span(m.from, m.to) + '</span>' + (live ? '<b>Today</b>' : '') + '</div>' +
        rowHtml(m, side(m.a)) + rowHtml(m, side(m.b)) + '</div>';
    };
    var drawBracket = function () {
      var rd = function (k, inner) { return '<div class="mm-rd"><span class="mm-rd-k">' + k + '</span><div class="mm-rd-l">' + inner + '</div></div>'; };
      var pair = function (x, y) { return '<div class="mm-pair">' + mtHtml(x) + mtHtml(y) + '</div>'; };
      brBox.innerHTML =
        rd('Round one', pair('m1', 'm2') + pair('m3', 'm4')) +
        rd('Semi-finals', pair('s1', 's2')) +
        rd('The final', mtHtml('f')) +
        rd('The winner', '<div class="mm-win"><i aria-hidden="true">' + (champ ? '1' : '?') + '</i><div><b>' + (champ ? esc(champ.name) : 'Announced') + '</b><br><span>' + (champ ? 'Mushroom Madness 2026' : 'Sunday 25 October') + '</span></div></div>');
    };
    drawMatch(); drawBracket();
    matchBox.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('[data-vote]') : null; if (!b || !cur) return;
      var slug = b.getAttribute('data-vote');
      vote(cur.id, slug);
      track('mm_vote', { match: cur.id, pick: slug });
      drawMatch();
    });
  }

  track('mm_view', { packs: CAT.length });
})();
